import React from "react";
import { Col, Row, Space } from "antd";
import { roundToTwoDecimals } from "../../common/Number";
import { GenericCard } from "../../common/components/GenericCard";
import { SvgIcon } from "../../common/components/SvgIcon";

export interface NegotiationDealScoreProps {
    overallScore: number;
    overallGrade: string;
    averageScore: number;
}

export const NegotiationDealScore: React.FC<NegotiationDealScoreProps> = ({
    overallScore,
    overallGrade,
    averageScore,
}) => {
    return (
        <GenericCard
            type="primary"
            style={{
                marginTop: 20,
                fontWeight: 500,
            }}
        >
            <Row>
                <Col flex={1} style={{ fontSize: 16, display: "flex", alignItems: "center" }}>
                    <SvgIcon name="money" size={20} color="#5AD81D" style={{ marginRight: 8 }} />
                    Deal scorecard
                </Col>
                <Col>
                    <Space size={26}>
                        <div>
                            <span>Highest possible score: </span>
                            <span style={{ color: "#FF8400" }}>100%</span>
                        </div>
                        <div>
                            <span>Overall grade: </span>
                            <span style={{ color: "#FF8400" }}>
                                {overallScore}% ({overallGrade})
                            </span>
                            <span style={{ color: "#FF8400" }}> - Above average by </span>
                            <span style={{ color: "#FF8400" }}>
                                {roundToTwoDecimals(overallScore - averageScore)}%
                            </span>
                        </div>
                    </Space>
                </Col>
            </Row>
        </GenericCard>
    );
};
